import React from 'react';

import Badge from '@/components/Badge';

import styles from './style.less';

const Sep = () => <span className={styles.sep}>·</span>;

const Part = ({ label, children }) => (
  <span className={styles.part}>
    <span className={styles.partLabel}>{label}</span>
    {children}
  </span>
);

export const DefinitionRuleLine = ({
  typeFieldLabel,
  typeLabel,
  operatorFieldLabel,
  operatorLabel,
  valuesFieldLabel,
  values,
}) => (
  <div className={styles.line}>
    <Part label={typeFieldLabel}>
      <Badge type="group-item" status="default" text={typeLabel} />
    </Part>
    <Sep />
    <Part label={operatorFieldLabel}>
      <Badge type="group-item" status="default" text={operatorLabel} />
    </Part>
    <Sep />
    <Part label={valuesFieldLabel}>
      <span className={styles.values}>{values}</span>
    </Part>
  </div>
);

export const DefinitionGroupBlock = ({
  title,
  logicalOperatorFieldLabel,
  logicalOperatorLabel,
  children,
}) => (
  <div className={styles.groupBlock}>
    <div className={styles.groupHeader}>
      <span className={styles.groupTitle}>{title}</span>
      <Sep />
      <Part label={logicalOperatorFieldLabel}>
        <Badge type="group-item" status="info" text={logicalOperatorLabel} />
      </Part>
    </div>
    {children ? <div className={styles.groupBody}>{children}</div> : null}
  </div>
);

export const DefinitionDetailStack = ({ children }) => (
  <div className={styles.stack}>{children}</div>
);
